export default "__VITE_ASSET__e18ac03e__"